import { memo } from 'react';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ProductHighlightCloneButton from './ProductHighlightCloneButton';
import ProductHighlightCustomizePreview from './ProductHighlightCustomizePreview';
import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import HubSpotAppLink from 'crm-links/common/components/HubSpotAppLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ProductHighlightActions({
  objectId,
  onObjectCreate,
  hasScope,
  hasGate
}) {
  return /*#__PURE__*/_jsx("div", {
    className: "text-right p-right-6 p-y-6",
    children: /*#__PURE__*/_jsx(UIDropdown, {
      buttonUse: "link",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "actions.title"
      }),
      "data-test-id": "product-highlight-actions",
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsx(ProductHighlightCustomizePreview, {
          hasScope: hasScope,
          hasGate: hasGate
        }), /*#__PURE__*/_jsx(HubSpotAppLink, {
          linkType: "CRM_OBJECT_RECORD_ALL_PROPERTIES",
          linkTypeProps: {
            includeEschref: true,
            objectTypeId: PRODUCT_TYPE_ID,
            objectId
          },
          LinkComponentProps: {
            'data-test-id': 'view-all-properties-button'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "actions.viewAllProperties"
          })
        }), /*#__PURE__*/_jsx(ProductHighlightCloneButton, {
          objectId: objectId,
          onObjectCreate: onObjectCreate
        })]
      })
    })
  });
}
export default /*#__PURE__*/memo(ProductHighlightActions);